import { useEffect, useState } from 'react';

export default function useTimer(activated: boolean, precision: number = 1000) {
  const [timePassed, setTimePassed] = useState<number>(0);

  useEffect(() => {
    if (!activated) return;
    const interval = setInterval(() => {
      setTimePassed((prevTime) => prevTime + precision);
    }, precision);

    // eslint-disable-next-line consistent-return
    return () => clearInterval(interval);
  }, [precision, activated]);

  return timePassed;
}
